import { render, staticRenderFns } from "./TicketInfoBar.vue?vue&type=template&id=0ba6fc62&scoped=true&"
import script from "./TicketInfoBar.vue?vue&type=script&lang=ts&"
export * from "./TicketInfoBar.vue?vue&type=script&lang=ts&"
import style0 from "./TicketInfoBar.vue?vue&type=style&index=0&id=0ba6fc62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba6fc62",
  null
  
)

export default component.exports